import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import DemoSection from "./components/DemoSection";
import StatsSection from "./components/StatsSection";
import DownloadSection from "./components/DownloadSection";
import FooterSection from "./components/FooterSection";
import { defaultLandingStats, fetchLandingStats, type LandingStats } from "@/lib/landingStats";

type Theme = "dark" | "light";
type Lang = "fr" | "en" | "ar";

export default function Home() {
  const [theme, setTheme] = useState<Theme>("dark");
  const [lang, setLang] = useState<Lang>("fr");
  const [landingStats, setLandingStats] = useState<LandingStats>(defaultLandingStats);
  const toggleTheme = () => setTheme(t => (t === "dark" ? "light" : "dark"));

  useEffect(() => {
    let cancelled = false;
    void fetchLandingStats().then((data) => {
      if (!cancelled) setLandingStats(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div style={{ fontFamily: lang === "ar" ? "'Tajawal', -apple-system, system-ui, sans-serif" : "-apple-system, 'SF Pro Text', system-ui, sans-serif", background: theme === "dark" ? "#000000" : "#F2F2F7", minHeight: "100vh" }}>
      <Navbar theme={theme} onThemeToggle={toggleTheme} lang={lang} onLangChange={setLang} />
      <main>
        <HeroSection theme={theme} lang={lang} stats={landingStats} />
        <FeaturesSection theme={theme} lang={lang} />
        <HowItWorksSection theme={theme} lang={lang} />
        <DemoSection theme={theme} lang={lang} />
        <StatsSection theme={theme} lang={lang} stats={landingStats} />
        <DownloadSection theme={theme} lang={lang} stats={landingStats} />
      </main>
      <FooterSection theme={theme} lang={lang} onLangChange={setLang} onThemeToggle={toggleTheme} />
    </div>
  );
}
